import { render, staticRenderFns } from "./connection.vue?vue&type=template&id=2a30bd6b&lang=html&"
import script from "./connection.vue?vue&type=script&lang=js&"
export * from "./connection.vue?vue&type=script&lang=js&"
import style0 from "./connection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports